module.exports = __webpack_public_path__ + "static/media/svg.6ba2fb4a.svg";